import type { FC, HTMLAttributes } from "react";
import { BASE_URL, UPLOAD_IMAGES } from "../utils/constants";
import { useIES } from "../hooks/useIES";

type HeaderData = {
  label: string;
  content: string;
};

type Props = {
  caption: string;
  data: HeaderData[];
};

type Style = HTMLAttributes<HTMLDivElement>["style"];

const PdfPreviewHeader: FC<Props> = ({ caption, data }) => {
    const { IES, isLoading } = useIES();
  const wrapper: Style = {
    width: 565,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "1px solid #000",
    fontFamily: '"DejaVu Sans", Arial, Helvetica, sans-serif',
    color: "#000",
    paddingBottom: 10,
  };

  const emblemWrapper: Style = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
    paddingBottom: 10,
  };

  const emblemImage: Style = { width: 56.9, height: 59 };

  const emblemMainCaption: Style = {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 14,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
  };

  const emblemSubCaption: Style = {
    color: "#000",
    fontSize: 12,
    textAlign: "center",
  };

  const dataWrapper: Style = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "left",
    paddingLeft: 4,
  };

  const dataText: Style = {
    marginBottom: 10,
    width: "100%",
    textAlign: "center",
  };

  const dataLabel: Style = {
    display: "inline-block",
    width: 84.6,
    textAlign: "left",
    fontSize: 12,
    fontWeight: "bold",
  };

  const dataContent: Style = {
    display: "inline-block",
    width: 197.4,
    textIndent: 0,
    textAlign: "left",
    fontSize: 12,
    margin: 0,
  };

  return (
    <div style={wrapper}>
      <div style={emblemWrapper}>
        <img
          src={`${IES.LOGO}`}
          alt="Emblem" style={emblemImage} />
        <h1 style={emblemMainCaption}>Esura</h1>
        <h2 style={emblemSubCaption}>{caption}</h2>
      </div>
      {/* <div style={dataWrapper}>
        {data.map((item, index) => (
          <div key={index} style={dataText}>
            <span style={dataLabel}>{item.label}</span>
            <span style={dataContent}>{item.content}</span>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default PdfPreviewHeader;
